import { Project } from '../../../service/Project'

const addLayer = ({ commit }, {layer, style, position}) => {
  commit('addLayer', {layer, style, position})
}
const addLayers = ({ commit }, layers) => {
  layers.forEach(layer => {
    const style = layer.style
    const position = layer.position || 0
    commit('addLayer', {layer, style, position})
  })
}
const addProjectLayer = async ({ dispatch, commit }, {projectId, layerId}) => {
  const payload = {
    'projectId': projectId,
    'layerId': layerId,
    'position': 0
  }
  const backEnd = Project.build({})
  return await backEnd.addLayer(payload)
}

const associateProject = async ({ dispatch, commit }, payload) => {
  const backEnd = Project.build({})
  await backEnd.associateToUser(payload)
}

const bootstrapActiveProject = async ({ dispatch, commit, rootState }, {session, userContext, defaultName}) => {
  commit('setStatus', 'loading')
  commit('setError', null)

  const backEnd = Project.build({})
  const environmentId = userContext.getEnvironmentId()
  const userId = userContext.getUserId()

  try {
    // 1) getActive
    let res = await backEnd.getActive(environmentId, userId)
    let projectId = null
    let activeProject = null

    if (res.status === 200) {
      activeProject = res.data || []

      // 2) se não existir: cria + vincula
      if (activeProject.length === 0) {
        const created = await backEnd.createProject(defaultName, environmentId, userId)
        const createdId = created.objectid || created.data.objectid || created.data.objectId
        if (!createdId) throw new Error('createProject não retornou objectid')

        const vinc = await backEnd.vinculateProjectUser(createdId, environmentId, userId)
        projectId = vinc.objectid || vinc.data.objectid || createdId
      } else {
        projectId = activeProject[0].project.objectid
      }
    } else {
      // fallback: cria projeto
      const created = await backEnd.createProject(defaultName, environmentId, userId)
      const createdId = created.objectid || created.data.objectid || created.data.objectId
      if (!createdId) throw new Error('createProject fallback não retornou objectid')

      await backEnd.vinculateProjectUser(createdId, environmentId, userId)
      projectId = createdId
    }

    if (!projectId) throw new Error('Não foi possível determinar projectId')

    // 3) persistir activeProjectId (session é infra)
    session.set('activeProject', projectId)

    // 4) store state
    commit('setActiveProject', { activeProject })

    // 5) loadProjectOptions → store
    await dispatch('getProjectMetadata', environmentId, projectId)

    // 6) loadProjectLayers → hidrata módulo layer
    res = await backEnd.getLayers(projectId)
    if (res.status === 200) {
      const layers = res.data || []
      // await dispatch('loadProjectLayers', projectId)
      await dispatch('map/addLayers', layers, {root: true})
    }
    commit('setStatus', 'ready')
    return projectId
  } catch (err) {
    commit('setStatus', 'error')
    commit('setError', err.message || String(err))
    throw err
  }
}

const changeLayers = async ({ dispatch, commit }, payload) => {
  const backEnd = Project.build({})
  await backEnd.changeLayers(payload)
}

const createProjectMetadata = async ({ dispatch, commit }, payload) => {
  const backEnd = Project.build({})
  await backEnd.createOptions(payload)
}

const getCurrent = async ({ dispatch, commit }, environmentId, userId) => {
  const backEnd = Project.build({})
  await backEnd.getActive(environmentId, userId)
}

const getProjectMetadata = async ({ dispatch, commit }, environmentId, projectId) => {
  const backEnd = Project.build({})
  await backEnd.getOptions(projectId, environmentId)
}

const loadProject = async ({ dispatch, commit }, { environmentId, userId, projectId}) => {
  try {
    await dispatch('releasePrevious', {environmentId, userId, projectId})
    // await dispatch('startProject', {environmentId, userId})
  } catch (e) {
    throw e
  }
}

const loadProjectLayers = async ({ dispatch, commit }, projectId) => {
  const backEnd = Project.build({})
  await backEnd.getLayers(projectId)
}

const loadOptions = async ({ dispatch, commit }, {environmentId, projectId}) => {
  const backEnd = Project.build({})
  try {
    const res = await backEnd.getOptions(projectId, environmentId)
    commit('setOptions', res.status === 200 ? res.data : {})
  } catch (e) {
    throw e
  }
}

const newProject = async ({ dispatch, commit }, {name, description}) => {
  const backEnd = Project.build({})
  const project = await backEnd.create(name, description)
  await commit('setActiveProject', { activeProject: project})
  await commit('legend/setAllLegend', [], { root: true })
  return project
}

const releasePrevious = async ({ dispatch, commit }, {environmentId, userId, projectId}) => {
  const backEnd = Project.build({})
  await backEnd.setActiveProjectAndDeactivateOthers(environmentId, userId, projectId)
}

const removeLayer = async ({ dispatch, commit }, {projectId, layerId}) => {
  try {
    const backEnd = Project.build({})
    await backEnd.deleteLayer(projectId, layerId)
    commit('removeLayer', layerId)
  } catch (e) {
    throw e
  }
}

const removeProject = async ({ dispatch, commit }, projectId) => {
  const backEnd = Project.build({})
  await backEnd.delete(projectId)
}

const renameProject = async ({ dispatch, commit }, {projectId, name}) => {
  const payload = {
    'ObjectId': projectId,
    'Name': name
  }
  const backEnd = Project.build({})
  await backEnd.rename(payload)
}

const saveProject = async ({ dispatch, commit }, projectId) => {

}

const saveOptions = async ({ dispatch, commit }, payload) => {
  const backEnd = Project.build({})

  try {
    if (payload.objectid <= 0)
      await backEnd.createOptions(payload)
    else
      await backEnd.updateOptions(payload)

    await commit('setOptions', payload)
  } catch (e) {
    throw e
  }
}

const startProject = async ({ getters, dispatch, commit }, {environmentId, userId}) => {
  const backEnd = Project.build({})

  try {
    await backEnd.getActive(environmentId, userId).then(async (res) => {
      let project = []
      if (res.status === 200) {
        if (res.data.length === 0) {
          const projectName = getters.getDefaultProjectName
          project = await dispatch('newProject', {name: projectName, description: ""})
        } else {
          project = res.data[0]
          await commit('setActiveProject', {activeProject: res.data[0].project})
          await commit('legend/setAllLegend', [], { root: true })
        }
        return [project]
      }
    })
  } catch (e) {

  }
}

const shareProject = async ({ dispatch, commit }, payload) => {
  const backEnd = Project.build({})
  await backEnd.associateToUser(payload)
}

const updateProjectMetadata = async ({ dispatch, commit }, payload) => {
  const backEnd = Project.build({})
  await backEnd.updateOptions(payload)
}

export default {
  addLayer,
  addLayers,
  addProjectLayer,
  associateProject,
  bootstrapActiveProject,
  changeLayers,
  createProjectMetadata,
  getCurrent,
  getProjectMetadata,
  loadProject,
  loadProjectLayers,
  loadOptions,
  newProject,
  releasePrevious,
  removeLayer,
  removeProject,
  renameProject,
  saveProject,
  saveOptions,
  shareProject,
  startProject,
  updateProjectMetadata
}
